import { IStatMap } from "../contracts/StatMap";
import { IGetSolarPanelDataRequest } from "../contracts/SolarPanels";
import { IZeosApiResponse } from "../contracts/ZeosApi";
import { getDataAsync, postDataAsync } from "../ZeosApiExecutor";
import { ISolarPanel } from "./interfaces/ISolarPanel";

const API_BASE_URL = `/Solar`;

export const SolarPanel: ISolarPanel = {
  getSolarStats: async (
    solarStatsRequest: IGetSolarPanelDataRequest
  ): Promise<IZeosApiResponse<IStatMap>> => {
    return await postDataAsync<IStatMap>(
      `${API_BASE_URL}/statistics`,
      solarStatsRequest
    );
  },
  getMonthlyProduction: async (
    solarPanelDataRequest: IGetSolarPanelDataRequest
  ): Promise<IZeosApiResponse<any[]>> => {
    return await postDataAsync<any[]>(
      `${API_BASE_URL}/monthly-production`,
      solarPanelDataRequest
    );
  },
  getYearlyProduction: async (
    solarPanelDataRequest: IGetSolarPanelDataRequest
  ): Promise<IZeosApiResponse<any[]>> => {
    return await postDataAsync<any[]>(
      `${API_BASE_URL}/yearly-production`,
      solarPanelDataRequest
    );
  },
  getSystemData: async (propertyId: number): Promise<IZeosApiResponse<any>> => {
    return await getDataAsync<any>(`${API_BASE_URL}/system/${propertyId}`, "");
  },
  getEstimatedData: async (
    propertyId: number
  ): Promise<IZeosApiResponse<any[]>> => {
    return await getDataAsync<any[]>(
      `${API_BASE_URL}/estimated/${propertyId}`,
      ""
    );
  },
};
